module.exports = __webpack_public_path__ + "static/disability_card_img3@2x-3a6d35a3f6d880e3c483b90c492d7e3a.jpg";